module.exports = __webpack_public_path__ + "img/tap.d7fa6bfc.png";